import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode } from "vue"

import { computed } from 'vue';

    
export default /*@__PURE__*/_defineComponent({
  __name: 'Badge',
  props: {
        label: {
            type: String,
            required: true
        },
        bgColour: {
            type: String,
            default: 'tw-bg-slate-200'
        },
        textColour: {
            type: String,
            default: 'tw-text-slate-700'
        },
        textSize: {
            type: String,
            default: 'tw-text-sm'
        },
        icon: {
            type: String,
            default: null
        },
        iconColour: {
            type: String,
            default: null
        },
        dense: {
            type: Boolean,
            default: false
        }
    },
  setup(__props) {

    const props = __props

    const bgClass = computed(() => {
        return 'tw-bg-'+props.bgColour
    })

return (_ctx: any,_cache: any) => {
  return (bgClass.value)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass(["tw-text-nowrap tw-flex tw-items-center tw-rounded-full tw-text-sm", __props.bgColour]),
        style: {"width":"max-content"}
      }, [
        (__props.icon)
          ? (_openBlock(), _createElementBlock("i", {
              key: 0,
              class: _normalizeClass([('mdi '+__props.icon) + (' '+__props.iconColour), "tw-text-[18px] tw-pr-[2px] tw-pl-[5px]"])
            }, null, 2))
          : _createCommentVNode("", true),
        _createElementVNode("div", {
          class: _normalizeClass(["tw-font-medium", __props.textColour, __props.textSize, (__props.icon ? 'tw-pr-3' : __props.dense ? 'tw-px-2' : 'tw-px-3'), (__props.dense ? 'tw-pb-[3px] tw-pt-[4px] tw-leading-none' : 'tw-py-[4px]')])
        }, _toDisplayString(__props.label), 3)
      ], 2))
    : _createCommentVNode("", true)
}
}

})